import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './index.css'
// PWA Update handling
import { registerSW } from 'virtual:pwa-register'

// Remove initial loader function
function removeInitialLoader() {
  const loader = document.getElementById('initial-loader');
  if (loader) {
    loader.style.opacity = '0';
    setTimeout(() => {
      if (loader.parentNode) {
        loader.parentNode.removeChild(loader);
      }
    }, 300);
  }
}

const root = ReactDOM.createRoot(document.getElementById('root')!);

// Render the app and remove loader once mounted
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Remove loader after React has had time to mount
setTimeout(removeInitialLoader, 500);

// PWA Update handling - automatically registers service worker
const updateSW = registerSW({
  onNeedRefresh() {
    // Force immediate update instead of prompting user
    console.log('New app version available, updating...');
    updateSW(true);
  },
  onOfflineReady() {
    console.log('App ready to work offline');
  },
  onRegisteredSW(swUrl: string, registration: any) {
    console.log('SW registered: ', swUrl);
    
    // Check for updates every 60 seconds
    if (registration) {
      setInterval(() => {
        registration.update();
      }, 60000);
    }
  },
  onRegisterError(error: any) {
    console.log('SW registration error', error);
  }
});
